import { Type } from "../Type";
export function fromIs(name, is) {
    return new IslyFromIs(name, is);
}
export class IslyFromIs extends Type {
    isFunction;
    class = "fromIs";
    constructor(name, isFunction) {
        super(name);
        this.isFunction = isFunction;
    }
    is = (value) => this.isFunction(value);
}
//# sourceMappingURL=index.js.map